import { useEffect, useRef } from 'react';

import { useDropdownActions } from '../../../controllers/store/dropdown';
import { useLogException } from '../../error-boundary/utils';
import { useBootstrap } from '../../store/bootstrap';
import { prefetchRecentSearchResults } from '../fetch-recent-search-results';
import { prefetchRecentViewsResults } from '../fetch-recent-views-results';

export const useDropdownPrefetch = (): void => {
	const [{ user, primaryProduct, cloudId, thirdPartyConfigs }] = useBootstrap();
	const { setPrefetchedRecentSearchResults, setPrefetchedRecentViewsResults } =
		useDropdownActions();
	const viewsResultsFetched = useRef(false);
	const searchResultsFetched = useRef(false);

	const logException = useLogException();

	useEffect(() => {
		async function fetchRecentViewsResults() {
			// Only fetch once
			if (!cloudId || viewsResultsFetched.current) {
				return;
			}
			viewsResultsFetched.current = true;

			const recentViewsResults = await prefetchRecentViewsResults(
				cloudId,
				logException,
				thirdPartyConfigs,
			);
			setPrefetchedRecentViewsResults(recentViewsResults);
		}
		fetchRecentViewsResults();
	}, [setPrefetchedRecentViewsResults, cloudId, logException, thirdPartyConfigs]);

	useEffect(() => {
		if (searchResultsFetched.current) {
			return;
		}
		searchResultsFetched.current = true;
		const recentSearchResults = prefetchRecentSearchResults(primaryProduct, user?.id);
		if (recentSearchResults.length > 0) {
			setPrefetchedRecentSearchResults(recentSearchResults);
		}
	}, [primaryProduct, user, setPrefetchedRecentSearchResults]);
};
